import { render, staticRenderFns } from "./TreatmentPlanRequests.vue?vue&type=template&id=00aee80a&scoped=true&"
import script from "./TreatmentPlanRequests.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequests.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequests.vue?vue&type=style&index=0&id=00aee80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aee80a",
  null
  
)

export default component.exports